import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {Header} from '../../components/header/header';


@Component({
  selector: 'app-main',
  imports: [
    RouterModule,
    Header
  ],
  template: `
    <div class="mobile-container">

      <app-header/>
      <main class="main-content page-padding">
        <router-outlet/>
      </main>


    </div>


  `,
  styleUrl: './main.scss',
})
export class Main {


}
